<template>
  <div
    id="registration"
    class="registration"
  >
    <div class="content">
      <Navbar :is-logged-in="false" />
      <div class="box-parent py-5">
        <div class="white-box">
          <p class="text-one mb-2">
            <strong>{{ $t("registration.text-one") }}</strong>
          </p>
          <p class="text-two">
            {{ $t("registration.text-two") }}
          </p>
          <form class="pt-3">
            <div class="email mb-4">
              <p class="text-label mb-1">
                {{ $t("registration.label.username") }}
              </p>
              <input
                v-model.trim="$v.registration.username.$model"
                type="text"
                class="form-control form-control-sm col-12 text-input"
                :placeholder="$t('registration.placeholder.username')"
                :class="{
                  'is-invalid': $v.registration.username.$error
                }"
              >
              <div class="invalid-css">
                <span
                  v-if="
                    !$v.registration.username.required &&
                      $v.registration.username.$error === true
                  "
                >{{ $t("registration.form-error.username-required") }}</span>
                <span
                  v-if="!$v.registration.username.maxLength"
                >{{ $t("registration.form-error.username-maxlength") }}</span>
                <span
                  v-if="!$v.registration.username.alpha"
                >{{ $t("registration.form-error.username-alpha") }}</span>
              </div>
            </div>
            <div class="email mb-4">
              <p class="text-label mb-1">
                {{ $t("registration.label.email") }}
              </p>
              <input
                v-model.trim="$v.registration.email.$model"
                type="text"
                class="form-control form-control-sm col-12 text-input"
                :placeholder="$t('registration.placeholder.email')"
                :class="{
                  'is-invalid': $v.registration.email.$error
                }"
              >
              <div class="invalid-css">
                <span
                  v-if="
                    !$v.registration.email.required &&
                      $v.registration.email.$error === true
                  "
                >{{ $t("registration.form-error.email-required") }}</span>
                <span v-if="!$v.registration.email.email">{{
                  $t("registration.form-error.email-email")
                }}</span>
              </div>
            </div>
            <div class="password mb-4">
              <p class="text-label mb-1">
                {{ $t("registration.label.password") }}
              </p>
              <input
                v-model.trim="$v.registration.password.$model"
                type="password"
                class="form-control form-control-sm col-12 text-input"
                :placeholder="$t('registration.placeholder.password')"
                :class="{
                  'is-invalid': $v.registration.password.$error
                }"
              >
              <div class="invalid-css">
                <span
                  v-if="
                    !$v.registration.password.required &&
                      $v.registration.password.$error === true
                  "
                >{{ $t("registration.form-error.password-required") }}</span>
                <span v-if="!$v.registration.password.minLength">{{
                  $t("registration.form-error.password-minlength")
                }}</span>
              </div>
            </div>
            <div class="copassword">
              <p class="text-label mb-1">
                {{ $t("registration.label.copassword") }}
              </p>
              <input
                v-model.trim="$v.registration.copassword.$model"
                type="password"
                class="form-control form-control-sm col-12 text-input"
                :placeholder="$t('registration.placeholder.copassword')"
                :class="{
                  'is-invalid':
                    registration.password !==
                    registration.copassword ||
                    $v.registration.copassword.$error
                }"
              >
              <div class="invalid-css">
                <span
                  v-if="
                    registration.copassword !==
                      registration.password &&
                      registration.copassword !== ''
                  "
                >{{
                  $t("registration.form-error.confirmpassword-notsame")
                }}</span>
                <span
                  v-if="
                    !$v.registration.copassword.required &&
                      $v.registration.copassword.$error === true
                  "
                >{{
                  $t("registration.form-error.confirmpassword-required")
                }}</span>
              </div>
            </div>
          </form>
          <div
            v-if="isLoading"
            class="button-next mt-5"
          >
            <div class="button-next-child m-0">
              <div class="spinner-border spinner-border-sm">
                <span class="sr-only">
                  Loading...
                </span>
              </div>
            </div>
          </div>
          <div
            v-else
            class="button-next mt-5"
            @click="nextScreen()"
          >
            <div class="button-next-child m-0">
              {{ $t("registration.button-next") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalUnsuccessful
      v-show="modal.unsuccessful"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import Api from '@/utils/Api'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'
import Navbar from '@/components/Navbar'
import {
  required,
  minLength,
  maxLength,
  email,
  helpers,
  alpha
} from 'vuelidate/lib/validators'

export default {
  name: 'Registerpageone',

  components: {
    Navbar,
    ModalUnsuccessful
  },

  data () {
    return {
      registration: {
        username: '',
        email: '',
        password: '',
        copassword: ''
      },
      modal: {
        unsuccessful: false,
        textModal: ''
      },
      isLoading: false
    }
  },

  mounted () {
    if (localStorage.getItem('Registration')) {
      const locRegistration = JSON.parse(localStorage.getItem('Registration'))
      this.registration = locRegistration
    }
  },

  methods: {
    showModal (modalname) {
      this.modal[modalname] = true
    },
    closeModal (modalname) {
      this.modal[modalname] = false
    },
    async nextScreen () {
      this.$v.$touch()
      if (!this.$v.$invalid && (this.registration.copassword === this.registration.password)) {
        this.isLoading = true
        const data = await Api.auth.registerCheck({
          username: this.registration.username,
          email: this.registration.email
        })
        this.isLoading = false
        if (data.status === 409) {
          this.modal.textModal = this.$i18n.locale === 'en' ? data.data.message.messageEng : data.data.message.messageIdn
          this.showModal('unsuccessful')
        }
        if (data.status === 200) {
          localStorage.Registration = JSON.stringify(this.registration)
          this.$router.push({
            name: 'personaldata'
          })
          window.scrollTo(0, 0)
        }
      }
    }
  },

  validations: {
    registration: {
      username: {
        required,
        alpha: helpers.regex(alpha, /^(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/i),
        minLength: minLength(8),
        maxLength: maxLength(20)
      },
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(255)
      },
      copassword: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(255)
      }
    }
  }
}
</script>

<style scoped>
.registration {
  background-color: #f5efff;
}
.content {
  background-image: url("~@/assets/image/bg-2.png");
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
  min-height: 100vh;
}
.box-parent {
  position: relative;
}
.white-box {
  background: white;
  height: 600px;
  width: 390px;
  border-radius: 18px;
  margin: 0 auto;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 40px;
}
.white-box > .text-one {
  color: #121212;
  font-family: Montserrat;
  font-size: 19px;
  line-height: 24px;
  text-align: left;
}
.white-box > .text-two {
  color: #18b2bd;
  font-family: Montserrat;
  font-size: 13px;
  line-height: 17px;
  text-align: left;
  font-weight: 600;
  padding-bottom: 30px;
  border-bottom: 1px solid #dedede;
}
.text-label {
  font-size: 12px;
  font-weight: bold;
  line-height: 14px;
}
.text-input {
  font-weight: 400;
}
.text-input::-webkit-input-placeholder {
  font-weight: 400;
  font-size: 12px;
  color: #aaaaaa;
}
.button-next {
  padding-left: 10px;
  padding-right: 10px;
}
.button-next-child {
  background-color: #18b2bd;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 4px;
  color: white;
  font-weight: 600;
  cursor: pointer;
}
.button-next-child:hover {
  background-color: #18b2bdc2;
}
.invalid-css {
  height: 10px;
  font-size: 12px;
  color: rgb(197, 0, 0);
}
</style>
